// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"910":"839b295d","2589":"d6fdf0fb","9414":"45aa4c3b","9671":"d0c0450a"}[chunkId] + ".css";
};